/**
 * FUNCTION: formatNumber
 * returns a formats number 1000000 = 1 000 000 for readability purposes
 * @param number to be formatted
 **/
const formatNumber = (number) => {
  let str = number.toString().split('.');
  if (str[0].length >= 5) {
    str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
  }
  if (str[1] && str[1].length >= 5) {
    str[1] = str[1].replace(/(\d{3})/g, '$1 ');
  }
  return str.join('.');
}

/**
 * FUNCTION: currencySymbol
 * returns the correct format for the given currency e.g.
 * USD = $9.99
 * SEK = 9.99 kr
 * @param currency
 * @param number to be formatted
 * @return {string}
 */
const currencySymbol = (currency, number) => {
  if ([' zł',' ₽', ' kr', 'د.إ'].includes(currency)) {
    return (number ? formatNumber(number.toFixed(2)) : '0.00') + currency;
  } else {
    return ((currency || '') + (number ? formatNumber(number.toFixed(2)) : '0.00'));
  }
}

export { currencySymbol };
